import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Icon from 'base-ui/dist/Icon';
import messages from './messages';

function IsOnline({ type }) {
  if (String(type).toLowerCase() === 'online') {
    return (
      <span className="meta regent-grey-color display-block">
        <Icon prefix="fas" name="globe" />
        {' '}
        <FormattedMessage {...messages.onlineAndAtYourOwnPace} />
      </span>
    );
  }
  return '';
}

IsOnline.propTypes = {
  type: PropTypes.string,
};

export default IsOnline;
